var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainTargetKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 11.0002H2V15.0042C2 15.5502 2.45 16.0002 3 16.0002C3.55 16.0002 4 15.5502 4 15.0042V13.0002H6V15.0002C6 15.5502 6.45 16.0002 7 16.0002C7.55 16.0002 8 15.5502 8 15.0002V13.0002H12.1C12.3509 14.2115 13.0418 15.2869 14.0393 16.0186C15.0367 16.7504 16.2699 17.0866 17.5007 16.9622C18.7315 16.8379 19.8726 16.2619 20.7035 15.3455C21.5345 14.4291 21.9964 13.2372 22 12.0002C22.0012 10.7602 21.5417 9.56402 20.7106 8.64382C19.8795 7.72362 18.7362 7.14506 17.5025 7.02044C16.2688 6.89583 15.0329 7.23406 14.0345 7.96947C13.0362 8.70488 12.3467 9.785 12.1 11.0002ZM17 15.0002C16.2043 15.0002 15.4413 14.6841 14.8787 14.1215C14.3161 13.5589 14 12.7958 14 12.0002C14 11.2045 14.3161 10.4414 14.8787 9.87883C15.4413 9.31622 16.2043 9.00015 17 9.00015C17.7956 9.00015 18.5587 9.31622 19.1213 9.87883C19.6839 10.4414 20 11.2045 20 12.0002C20 12.7958 19.6839 13.5589 19.1213 14.1215C18.5587 14.6841 17.7956 15.0002 17 15.0002Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainTargetKeyIcon);
export default __webpack_public_path__ + "static/media/MainTargetKeyIcon.f768e2af037c0d9efc595ba37849694f.svg";
export { ForwardRef as ReactComponent };